import { render, staticRenderFns } from "./Confirmation.vue?vue&type=template&id=198d6c3a&"
import script from "./Confirmation.vue?vue&type=script&lang=js&"
export * from "./Confirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('198d6c3a')) {
      api.createRecord('198d6c3a', component.options)
    } else {
      api.reload('198d6c3a', component.options)
    }
    module.hot.accept("./Confirmation.vue?vue&type=template&id=198d6c3a&", function () {
      api.rerender('198d6c3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layout/Confirmation.vue"
export default component.exports